export interface DragItemData {
  itemId: string;
  selectedIds: string[];
}

export const DROPPABLE_FOLDER_PREFIX = 'folder:';
export const DROPPABLE_BREADCRUMB_PREFIX = 'breadcrumb:';
export const DROPPABLE_BREADCRUMB_ROOT = 'breadcrumb:root';
export const DROPPABLE_BREADCRUMB_SIXROOT = 'breadcrumb:sixroot';
